import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import Skeleton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Skeleton';
import React from 'react';

const RoadmapExecutiveSummarySkeleton = () => {
  const theme = useTheme();
  const isMobile = useMobileLayout();
  return (
    <FDContentContainer maxWidth={'xl'}>
      <FDStack direction={'column'} alignItems={'center'} spacing={3} width={'100%'} paddingY={isMobile ? 4 : 0}>
        <Skeleton style={{ borderRadius: theme.radius.md }} variant={'rect'} width={'100%'} height={28} />
        <FDStack direction={isMobile ? 'column' : 'row'} spacing={isMobile ? 2 : 8} width={'100%'}>
          <Skeleton style={{ borderRadius: theme.radius.md }} variant={'rect'} width={isMobile ? '100%' : '40%'} height={700} />
          <Skeleton style={{ borderRadius: theme.radius.md }} variant={'rect'} width={isMobile ? '100%' : '60%'} height={700} />
        </FDStack>
        <Skeleton style={{ borderRadius: theme.radius.md }} variant={'rect'} width={'100%'} height={120} />
      </FDStack>
    </FDContentContainer>
  );
};

export { RoadmapExecutiveSummarySkeleton };
